import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HeroSectionComponent } from "./Sections/hero-section/hero-section.component";
import { FeaturedServicesSectionComponent } from './Sections/featured-services-section/featured-services-section.component';
import { StatsSectionComponent } from "./Sections/stats-section/stats-section.component";
import { FeaturesDetailsSectionComponent } from "./Sections/features-details-section/features-details-section.component";
import { ServicesSectionComponent } from "./Sections/services-section/services-section.component";
import { PricingSectionComponent } from "./Sections/pricing-section/pricing-section.component";
import { ContactSectionComponent } from "./Sections/contact-section/contact-section.component";

@Component({
  selector: 'kt-app-home',
  standalone: true,
  imports: [
    CommonModule,
    HeroSectionComponent,
    FeaturedServicesSectionComponent,
    StatsSectionComponent,
    FeaturesDetailsSectionComponent,
    ServicesSectionComponent,
    PricingSectionComponent,
    ContactSectionComponent
],
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss']
})
export class HomeComponent {
}